<template>
  <gs1-alert>
    <p>{{ $t('title') }}</p>
    <i18n path="message" tag="p" class="small">
      <a href="https://www.gs1-germany.de/service/kontakt/" target="_blank" rel="noopener">{{ $t('contact_gs1') }}</a>
    </i18n>
  </gs1-alert>
</template>

<script>
import Gs1Alert from './Gs1Alert'
export default {
  name: 'Gs1AlertNonNumeric',
  components: {
    Gs1Alert
  },
  i18n: {
    messages: {
      de: {
        title: 'Diese GTIN konnte nicht gefunden werden.',
        message: 'Diese GTIN konnte keiner gültigen GS1 Lizenz zugeordnet werden. Bitte {0} wenn Sie Hilfe benötigen.',
        contact_gs1: 'kontaktieren Sie GS1'
      },
      en: {
        title: 'We can’t find this number.',
        message: 'This GTIN could not be assigned to a valid GS1 license. Please {0} if you need help.',
        contact_gs1: 'contact GS1'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/alerts/Gs1AlertNotFound.vue